const initPlaylistCovers = (root) => {
    const apiBase = root.dataset.apiBase || 'https://api.onerpm.com/playlistCovers';
    const storesApi = root.dataset.storesApi || `${apiBase}/stores`;

    const initialLoader = root.querySelector('[data-playlist-covers-initial-loader]');
    const content = root.querySelector('[data-playlist-covers-content]');
    const coversLoader = root.querySelector('[data-playlist-covers-loader]');
    const grid = root.querySelector('[data-playlist-covers-grid]');
    const empty = root.querySelector('[data-playlist-covers-empty]');
    const storeSelect = root.querySelector('[data-playlist-covers-store]');
    const pageSelect = root.querySelector('[data-playlist-covers-page]');
    const pageTotal = root.querySelector('[data-playlist-covers-total]');
    const searchInput = root.querySelector('[data-playlist-covers-search]');
    const prevButton = root.querySelector('[data-playlist-covers-prev]');
    const nextButton = root.querySelector('[data-playlist-covers-next]');
    const perPageButtons = Array.from(
        root.querySelectorAll('[data-playlist-covers-per-page]')
    );
    console.log(apiBase);

    if (!content || !grid || !pageSelect) {
        return;
    }

    const state = {
        initialLoaded: false,
        coversLoading: false,
        page: 1,
        perPage: 48,
        lastPage: 1,
        store: '',
        playlistName: '',
        filterTimer: null,
    };
    const columnsMobile = Number(root.dataset.columnsMobile) || 2;
    const columnsTablet = Number(root.dataset.columnsTablet) || 3;
    const columnsDesktop = Number(root.dataset.columnsDesktop) || 4;

    const clampColumns = (value) => {
        if (!Number.isFinite(value)) {
            return 1;
        }
        return Math.min(6, Math.max(1, value));
    };

    const getColumnSize = (value) => {
        const columns = clampColumns(value);
        return Math.max(1, Math.floor(12 / columns));
    };

    const getColumnClass = () => {
        const mobileSize = getColumnSize(columnsMobile);
        const tabletSize = getColumnSize(columnsTablet);
        const desktopSize = getColumnSize(columnsDesktop);
        return `col-${mobileSize} col-md-${tabletSize} col-lg-${desktopSize}`;
    };

    const setInitialLoaded = () => {
        state.initialLoaded = true;
        if (initialLoader) {
            initialLoader.hidden = true;
        }
        content.hidden = false;
    };

    const setLoading = (isLoading) => {
        state.coversLoading = isLoading;
        if (!state.initialLoaded || !coversLoader) {
            return;
        }
        coversLoader.hidden = !isLoading;
        grid.hidden = isLoading;
    };

    const setEmpty = (isEmpty) => {
        if (!empty) {
            return;
        }
        empty.hidden = !isEmpty;
    };

    const setPagerState = () => {
        const isFirst = state.page <= 1;
        const isLast = state.page >= state.lastPage;
        if (prevButton) {
            prevButton.classList.toggle('is-disabled', isFirst);
            prevButton.setAttribute('aria-disabled', isFirst ? 'true' : 'false');
        }
        if (nextButton) {
            nextButton.classList.toggle('is-disabled', isLast);
            nextButton.setAttribute('aria-disabled', isLast ? 'true' : 'false');
        }
    };

    const updatePageOptions = () => {
        if (!pageSelect) {
            return;
        }
        pageSelect.innerHTML = '';
        for (let i = 1; i <= state.lastPage; i += 1) {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = i;
            if (i === state.page) {
                option.selected = true;
            }
            pageSelect.appendChild(option);
        }
        if (pageTotal) {
            pageTotal.textContent = state.lastPage;
        }
        setPagerState();
        if (window.jQuery && window.jQuery.fn && window.jQuery.fn.select2) {
            window.jQuery(pageSelect).trigger('change.select2');
        }
    };

    const renderCovers = (covers) => {
        grid.innerHTML = '';
        const fragment = document.createDocumentFragment();
        covers.forEach((item) => {
            const col = document.createElement('div');
            col.className = `${getColumnClass()}`;
            const coverName = item.playlist_name || '';
            col.innerHTML = `
                <div class="item">
                    <div class="img">
                        <img widt="500" height="500" src="${item.cover_url}" alt="${coverName}">
                    </div>
                </div>
            `;
            fragment.appendChild(col);
        });
        grid.appendChild(fragment);
    };

    const fetchStores = async () => {
        if (!storeSelect) {
            return;
        }
        try {
            const response = await fetch(storesApi);
            if (!response.ok) {
                return;
            }
            const data = await response.json();
            const items = Array.isArray(data.result) ? data.result : [];
            const currentValue = storeSelect.value;
            items.forEach((item) => {
                const storeValue = Array.isArray(item.store_ids)
                    ? item.store_ids.join(',')
                    : item.store_ids;
                if (!storeValue) {
                    return;
                }
                const option = document.createElement('option');
                option.value = String(storeValue);
                option.textContent = item.store_name;
                storeSelect.appendChild(option);
            });
            storeSelect.value = currentValue;
            if (window.jQuery && window.jQuery.fn && window.jQuery.fn.select2) {
                window.jQuery(storeSelect).trigger('change.select2');
            }
        } catch (error) {
            console.error('Playlist covers stores error:', error);
        }
    };

    const fetchCovers = async () => {
        if (state.initialLoaded) {
            setLoading(true);
        }
        const params = new URLSearchParams();
        params.set('page', state.page);
        params.set('perPage', state.perPage);
        if (state.store) {
            params.set('store_ids', state.store);
        }
        const trimmedName = state.playlistName.trim();
        if (trimmedName) {
            params.set('playlist_name', trimmedName);
        }

        try {
            const response = await fetch(`${apiBase}?${params.toString()}`);
            if (!response.ok) {
                throw new Error(`Bad response: ${response.status}`);
            }
            const data = await response.json();
            const result = Array.isArray(data.result) ? data.result : [];
            const paginate = data.paginate || {};
            state.lastPage = Number(paginate.last_page) || 1;
            state.page = Number(paginate.current_page) || state.page;

            renderCovers(result);
            setEmpty(result.length === 0);
            updatePageOptions();
        } catch (error) {
            console.error('Playlist covers error:', error);
            setEmpty(true);
        } finally {
            if (!state.initialLoaded) {
                setInitialLoaded();
            }
            setLoading(false);
        }
    };

    const scheduleFilter = () => {
        if (state.filterTimer) {
            clearTimeout(state.filterTimer);
        }
        state.page = 1;
        state.filterTimer = setTimeout(() => {
            fetchCovers();
        }, 300);
    };

    perPageButtons.forEach((button) => {
        button.addEventListener('click', () => {
            perPageButtons.forEach((item) => item.classList.remove('active'));
            button.classList.add('active');
            state.perPage = Number(button.dataset.count) || state.perPage;
            state.page = 1;
            fetchCovers();
        });
    });

    prevButton?.addEventListener('click', () => {
        if (state.page <= 1) {
            return;
        }
        state.page -= 1;
        fetchCovers();
    });

    nextButton?.addEventListener('click', () => {
        if (state.page >= state.lastPage) {
            return;
        }
        state.page += 1;
        fetchCovers();
    });

    const onPageChange = () => {
        const nextPage = Number(pageSelect.value);
        if (!Number.isNaN(nextPage) && nextPage !== state.page) {
            state.page = nextPage;
            fetchCovers();
        }
    };

    const onStoreChange = () => {
        state.store = storeSelect.value;
        state.page = 1;
        fetchCovers();
    };

    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.select2) {
        window.jQuery(pageSelect).on('change', onPageChange);
        if (storeSelect) {
            window.jQuery(storeSelect).on('change', onStoreChange);
        }
    } else {
        pageSelect.addEventListener('change', onPageChange);
        if (storeSelect) {
            storeSelect.addEventListener('change', onStoreChange);
        }
    }

    if (searchInput) {
        searchInput.addEventListener('input', (event) => {
            state.playlistName = event.target.value || '';
            scheduleFilter();
        });
    }

    const activeButton = perPageButtons.find((button) => button.classList.contains('active'));
    if (activeButton) {
        state.perPage = Number(activeButton.dataset.count) || state.perPage;
    }

    fetchStores();
    fetchCovers();
};

const init = () => {
    document
        .querySelectorAll('[data-playlist-covers="true"]')
        .forEach((root) => initPlaylistCovers(root));
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
